const API_URL = "https://lets-manage-7d2ea4f309ff.herokuapp.com";

export async function getAllByMatch(username, idT, idM) {
    if (!username) {
        throw new Error('Username not found in localStorage');
    }

    const url = `${API_URL}/users/${username}/teams/${idT}/matches/${idM}/playermatchstats`;
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.error || "Error obtaining playermatchstats by match");
        }
        
        return await response.json();
    } catch (error) {
        console.error("Error in getAllByMatch:", error);
        throw error;
    }
}
